import swal from "sweetalert2";
import AdminApi from "../../../services/api";
import session from "../../../services/session";
import CONFIG_COMPANY from "../../../services/myConfig";
import Loc from "../../../services/localization";

const AdminApiService = new AdminApi()
const LocService = new Loc()

export default {

    data() {
        return {
            locale: LocService,
            id: 0,
            partners: [],
            model: {
                day: 'MONDAY',
                maxTrainings: 0,
                startAt: '',
                trainingType: "",
                trainerOnSlot: null,
                predefinedUsers: []
            },
            types: [],
            isVisibleAddUserToTerm: false,
            selectedUsers: [],
            showAddTrainerToSlot: false,
            chooseUser: false,
            trainingNumbers: LocService.t('label_max_people_on_training')
        }
    },
    methods: {
        load: load,
        editTerm: editTerm,
        getUsersByIds: getUsersByIds,
        showChoseUser: showChoseUser,
        loadPartners: loadPartners,
        removeSelectedUser: removeSelectedUser,
        getTrainingTypes: getTrainingTypes
    },
    created() {
        let _self = this;
        this.$topnavbar.$on('closeChooseUser', () => {
            _self.chooseUser = false;
        });

        this.$topnavbar.$on('onUserSelected', (data) => {
            // _self.chooseUser = false;
            if(this.selectedUsers.filter(e => e.id === data.id).length === 0){
                _self.selectedUsers.push(data);
            }
        });
    },
    beforeMount() {
        if (session.getRole() !== 'ROLE_ADMIN' && session.getRole() !== 'ROLE_SUPER_ADMIN' && session.getRole() !== 'ROLE_TRAINER') {
            this.$router.push(CONFIG_COMPANY.HOME);
            return;
        }
        this.showAddTrainerToSlot = CONFIG_COMPANY.SHOW_ADD_TRAINER_ON_SLOT;
        this.isVisibleAddUserToTerm = session.getConfig().canAddUserWithTerm;
        this.id = this.$route.query.id
        this.load(this.$route.query.id)
        this.getTrainingTypes()
        if(this.showAddTrainerToSlot){
            this.loadPartners();
        }
    }
}

function loadPartners() {
    let _self = this;
    AdminApiService.getCompanyPayments()
        .then((response) => {
            _self.partners = response.data
        })
        .catch(error => {
            swal( LocService.t('label_error'), error.data.localized_error_message, 'error')
        })
}

function showChoseUser(){
    this.chooseUser = true;
}

function removeSelectedUser(user){
    this.selectedUsers =  this.selectedUsers.filter(item => item.id !== user.id);
}

function load(id) {
    let _self = this;
    AdminApiService.getTermsById(id)
        .then((response) => {
            _self.model = response.data
            if(response.data.predefinedUsers != null){
                if(response.data.predefinedUsers.length > 0){
                    let model = {
                        predefinedUsers: response.data.predefinedUsers.split(",").map(e => parseInt(e))
                    }
                    _self.model.predefinedUsers = response.data.predefinedUsers.split(",").map(e => parseInt(e));
                    _self.getUsersByIds(model)
                }
            }
        })
        .catch(error => {
            swal(LocService.t('label_error'), error.data.localized_error_message, 'error')
        })
}

function getUsersByIds(ids) {
    let _self = this;

    AdminApiService.getUsersByIds(ids)
        .then((response) => {
            _self.selectedUsers = response.data;
        })
        .catch(error => {
            swal(LocService.t('label_error'), error.data.localized_error_message, 'error')
        })
}

function editTerm() {
    let _self = this;
    if(this.selectedUsers.length > 0){
        var usersId = [];
        this.selectedUsers.forEach(e => {
            usersId.push(parseInt(e.id));
        })
        _self.model.predefinedUsers = usersId;
    }else{
        _self.model.predefinedUsers = [];
    }
    console.log(_self.model)
    AdminApiService.updateTerm(_self.model,_self.id)
        .then((response) => {
            swal(LocService.t('label_success'), LocService.t('label_term_edit_term_success'), 'success')
            this.$router.push('/pre-terms');

        })
        .catch(error => {
            swal(LocService.t('label_error'), error.data.localized_error_message, 'error')
        })
}

function getTrainingTypes() {
    let _self = this;
    AdminApiService.getTrainingTypes()
        .then((response) => {
            _self.types = response.data
        })
        .catch(error => {
            swal(LocService.t('label_error'), error.data.localized_error_message, 'error')
        })
}


// WEBPACK FOOTER //
// ./src/components/Term/Edit/EditTerm.js